import { render, staticRenderFns } from "./openNum.vue?vue&type=template&id=40bd445a&scoped=true&"
import script from "./openNum.vue?vue&type=script&lang=js&"
export * from "./openNum.vue?vue&type=script&lang=js&"
import style0 from "./openNum.vue?vue&type=style&index=0&id=40bd445a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40bd445a",
  null
  
)

export default component.exports